<template>
  <div id="menu" class="bg-white menu" style="padding-right: 3vw">
    <div id="contactBar" class="flex justify-end items-center text-unselected text-xs space-x-11" style="visibility: hidden">
      <div v-for="(item, index) in contactList" :key="'contactItem' + index" class="flex items-center">
        <img :src="'src/assets/images/menu/' + item.icon + '.svg'" class="pr-2.5" />
        <span>{{ t(item.description) }}</span>
      </div>
      <div id="langItem" class="flex items-center cursor-pointer">
        <img src="@/assets/images/menu/worldwide.svg" class="pr-2.5" />
        <span class="pr-4">{{ selectedLang.lang }}</span>
        <img src="@/assets/images/menu/expandmore.svg" />
      </div>
    </div>

    <div id="btnGrp" class="flex justify-end items-center text-base font-jost space-x-1">
      <button-util buttonType="button" :buttonIcon="{ componentName: 'header', imgName: 'telemedicine_icon', imgFormat: 'svg', width: '1.4vw' }" bgColor="transparent" labelColor="#7BA7D8" label="Telemedicine" @click="clearAndRouteTo('telemedicine')" />
      <button-util buttonType="button" :buttonIcon="{ componentName: 'header', imgName: 'covid19_icon', imgFormat: 'svg', width: '1.1vw' }" bgColor="transparent" labelColor="#1687A7" label="Covid-19" @click="clearAndRouteTo('covid19')" />
      <button-util buttonType="button" bgColor="#603813" label="Book your appointment" @click="clearAndRouteTo('bookyourappointment')" />
      <button-util buttonType="button" bgColor="#FFFFFF" labelColor="#603813" borderColor="0.2vw solid rgb(96, 56, 19)" label="Corporate Member Login" @click="clearAndRouteTo('login')" />
    </div>

    <div id="menuBar" class="flex items-end text-lg mt-4">
      <img
        src="@/assets/images/menu/companyLogoBig.png"
        class="cursor-pointer absolute"
        @click="clearAndRouteTo('home'); headerStore.routerName=null;"
        style="width: 30vw; image-rendering: crisp-edges; image-rendering: -moz-crisp-edges; image-rendering: -o-crisp-edges; image-rendering: -webkit-optimize-contrast; -ms-interpolation-mode: nearest-neighbor"
        v-if="!headerStore.isShowSmallIcon"
      />
      <img
        src="@/assets/images/menu/companyLogoSmall.png"
        class="cursor-pointer absolute ml-10"
        @click="clearAndRouteTo('home'); headerStore.routerName=null;"
        style="width: 6vw; image-rendering: crisp-edges; image-rendering: -moz-crisp-edges; image-rendering: -o-crisp-edges; image-rendering: -webkit-optimize-contrast; -ms-interpolation-mode: nearest-neighbor"
        v-else
      />

      <div class="flex justify-between w-full mb-2 menu-item" :style="headerStore.isShowSmallIcon ? 'margin-left: 10%' : 'margin-left:30%'">
        <template v-for="(item, index) in headerStore.menuList" :key="'menuItem' + index">
          <span 
            class="flex items-center cursor-default" 
            >
            <div
            @click="index < headerStore.menuList.length - 2 ? showNavBar(item) : jumpToPageFromMenuBar(item)" 
            :style="{ color: '#494949' }"
            :class="{
              'font-bold': isSelected(item.id),
              'underline-animation': true,
              'underline-maintain': isSelected(item.id),
              'corpColor': index == 0,
              'insuColor': index == 1,
              'patiColor': index == 2

              }">
              {{ t(item.label).toUpperCase() }}
            </div>
            
            <img
              v-if="(headerStore.selectedMenu.id == item.id || headerStore.routerName == item.id) && !(item.id == 'investorrelations' || item.id == 'workwithus' || item.id == 'aboutus')"
              class="ml-2"
              style="width: 1vw; height: 1vw;"
              src="@/assets/images/menu/arrow-up.svg"
            />
            <img
              v-if="!(headerStore.selectedMenu.id == item.id || headerStore.routerName == item.id) && !(item.id == 'investorrelations' || item.id == 'workwithus' || item.id == 'aboutus')"
              class="ml-2"
              style="width: 1vw; height: 1vw;"
              src="@/assets/images/menu/arrow-down.svg"
            />
          </span>
        </template>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted, onUpdated, onBeforeUnmount, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useHeaderStore } from "@/stores/header";
import { useCommonStore } from "@/stores/common";
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();

const headerStore = useHeaderStore();
const router = useRouter();
const commonStore = useCommonStore();

const contactList = [
  {
    icon: "wechat",
    iconType: "material_icons",
    description: "TrinityHealth",
  },
  {
    icon: "whatsapp",
    iconType: "material_icons",
    description: "3723 3050",
  },
  {
    icon: "email",
    iconType: "material_icons",
    description: "info@the-hk.com",
  },
];

const langList = [
  {
    lang: "English",
    icon: "",
  },
  {
    lang: "繁體中文",
    icon: "",
  },
];

var selectedLang = ref(langList[0]);

onMounted(async () => {
  window.addEventListener("resize", windowSizeEventHandler);
  companyLogoController(window.innerWidth);
  checkIfShowNavi();
});

onBeforeUnmount(async () => {
  console.log("leave getting window size");
  window.removeEventListener("resize", windowSizeEventHandler);
});

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};

const clearAndRouteTo = (position) => {
  headerStore.selectedMenu = {};
  headerStore.currentMenu = {};
  router.push({ name: position, params: { uid: "lczmx" } });
}

const jumpToPageFromMenuBar = (item) => { 
  if (item.id == 'workwithus' || item.id == 'aboutus') {
    headerStore.selectedMenu = {};
    headerStore.currentMenu = item;
  }
  else {
    headerStore.currentMenu = {};
    headerStore.selectedMenu = {};
  }

  router.push({ name: item.id, params: { uid: "lczmx" } });
}

const showNavBar = (item) => {
  console.log("selected item: ", item);
  headerStore.selectedMenu = item;
  //else headerStore.selectedMenu = {};
};

const leaveNavBar = (item) => {
  console.log("mouseleave");
  // if (item.navbarList == undefined) headerStore.selectedMenu = {};
  //else headerStore.selectedMenu = {};
};

const goToLocation = (id) => {

  if (
    id == "workwithus") {
    headerStore.routerName = id;
      routeTo(id);
  }

  if (id == "investorrelations")
    routeTo("comingsoon")

  if (
    headerStore.selectedMenu.id == "corporate" || 
    headerStore.selectedMenu.id == "insurer" || 
    headerStore.selectedMenu.id == "patients" || 
    headerStore.selectedMenu.id == "services" || 
    headerStore.selectedMenu.id == "aboutus")
    return;
  else routeTo("comingsoon");
  // headerStore.selectedMenu = {};
};

const windowSizeEventHandler = (e) => {
  //console.log("window size: " + window.innerHeight + " " + window.innerWidth);
  companyLogoController(window.innerWidth);
};

const companyLogoController = (windowWidth) => {
  if (windowWidth < headerStore.winowWidthToShowSmallLogo) {
    headerStore.isShowSmallIcon = true;
  } else {
    headerStore.isShowSmallIcon = false;
  }
};

const isSelected = (id) => {
  return headerStore.selectedMenu.id == id || headerStore.currentMenu.id == id;
}

const checkIfShowNavi = () => {
  switch (window.location.pathname.split('/')[1]) {
    case 'aboutcorporate':
    case 'corpvaccination':
    case 'corptelemedicine':
      headerStore.currentMenu = headerStore.menuList[0];
      headerStore.selectedMenu = headerStore.menuList[0];
      break;

    case 'aboutinsurer':
    case 'tpa':
    case 'insucheckupservices':
    case 'insuvaccination':
    case 'insutelemedicine':
    case 'emergencyassistance':
    case 'insunursing':
      headerStore.currentMenu = headerStore.menuList[1];
      headerStore.selectedMenu = headerStore.menuList[1];
      break;

    case 'aboutpatients':
    case 'paticheckupservices':
    case 'pativaccination':
    case 'patitelemedicine':
    case 'emergencyassistance':
    case 'patinursing':
      headerStore.currentMenu = headerStore.menuList[2];
      headerStore.selectedMenu = headerStore.menuList[2];
      break;

    case 'aboutservices':
    case 'servcheckupservices':
    case 'factsheet':
      headerStore.currentMenu = headerStore.menuList[3];
      headerStore.selectedMenu = headerStore.menuList[3];
      break;

    case 'workwithus':
      headerStore.currentMenu = headerStore.menuList[5];
      headerStore.selectedMenu = headerStore.menuList[5];
      break;
      
    case 'aboutus':
      headerStore.currentMenu = headerStore.menuList[4];
      headerStore.selectedMenu = {};
  
    default:
      break;
  }
}
</script>

<style scoped>
/*
@media only screen and (min-height: 3500px) and (max-height: 4300px) {
  .menu {
    height: 13vh !important;
  }
}*/

.menu-item {
  flex: 0 0 calc(70%);
}
.underline-animation {
  position: relative;
}

.underline-animation.corpColor::after {
  background-color: #8F8248;
}

.underline-animation.insuColor::after {
  background-color: #82488F;
}

.underline-animation.patiColor::after {
  background-color: #488F82;
}

.underline-animation::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0; /* Start from the left edge */
  width: 0;
  height: 0.1vw;
  background-color: #494949; /* Use the current text color */
  opacity: 0;
  transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

.underline-animation:hover::after,
.underline-animation:focus::after,
.underline-animation.underline-maintain::after {
  width: 100%; /* Spread to the right */
  opacity: 1;
  transition: width 0.1s ease-in-out, opacity 0.1s ease-in-out;
}
</style>